import { get, merge } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc AuthFlowMemberVerificationFamilyUnit defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AuthFlowMemberVerificationFamilyUnitService } from 'services/authFlowMemberVerificationFamilyUnit';
 *
 * // create service instance and send/cancel request
 * const authFlowMemberVerificationFamilyUnitService = new AuthFlowMemberVerificationFamilyUnitService();
 * const result = await authFlowMemberVerificationFamilyUnitService.fetchData( '<user-id>' ); // fetch data
 * authFlowMemberVerificationFamilyUnitService.cancel(); // cancel an active request
 */
export class AuthFlowMemberVerificationFamilyUnitService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                    }
                }, ),
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    titles: get( response, 'body.component.structure', {} ),
                    members: get( response, 'body.component.data.state.members', [] ),
                    options: get( response, 'body.component.data.options', [] ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
